<template>
  <td>
    <div v-if="content !== 0">
      <div @click="confirm()" class="btn btn-primary">
        {{ label || "Buchen" }}
      </div>
      <div @click="remove()" class="btn btn-danger">
        <i class="fa fa-trash-alt"></i>
      </div>
    </div>
    <i v-else class="fa fa-check" />
  </td>
</template>

<script lang="babel">
export default {
    props: ['content', 'label', 'model'],
    methods: {
      async confirm() {
        await this.$http.post(this.model.confirm_state_url);

        this.$bus.$emit('refresh-table');
      },
      async remove() {
        await this.$http.delete(this.model.delete_url);

        this.$bus.$emit('refresh-table');
      }
    },
};
</script>
